import { useMemo } from 'react';

import { useFiltersContext } from '../context';

import { getLocationIdForMetro } from './getLocationIdForMetro';

const DEFAULT_LOCATIONS_WITH_UNDERGROUND_MAP = [
  // Москва
  1,
  // Санкт-Петербург
  2,
  // Екатеринбург
  4743,
  // Казань
  4777,
  // Нижний Новгород
  4885,
  // Новосибирск
  4897,
  // Самара
  4966,
];

export function useHasUnderground(): boolean {
  const { config, currentLocation } = useFiltersContext();

  return useMemo(() => {
    const locationsWithUndergroundMap =
      config.get<number[]>('regionIdsWithMetro') || DEFAULT_LOCATIONS_WITH_UNDERGROUND_MAP;
    const locationId = getLocationIdForMetro(currentLocation);

    return locationsWithUndergroundMap.some(id => id === locationId);
  }, [config, currentLocation]);
  // TODO вернуть старую логику с проверкой региона для метро в задаче CD-181986, когда будет фикс на бекенде AUD-2226
  // currentLocation === 'spb_lo' || (isAvailableRegion(REGIONS_WITH_UNDERGROUND)(jsonQuery) &&
  //   availableMetroScheme.some(id => id === currentLocation.id))
}
